import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import {
  map, noop,
} from 'lodash';
import { Loading } from '../base';

export default class SelectTema extends Component {
  constructor(props) {
    super(props);
    this.state = {
      currentValue: '',
    };
    this.clickHandlers = {};
    this._setInputRef = this._setInputRef.bind(this);
    this._checkBlur = this._checkBlur.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onClick = this._onClick.bind(this);
    this._onClear = this._onClear.bind(this);
    this._onBlur = this._onBlur.bind(this);
    this.SelectTemaRefs = null;
    this.canBlur = true;
  }

  _setInputRef(ref) {
    this.SelectTemaRefs = ref;
  }

  _onChange(event) {
    const val = event.target.value;
    const { onSearchTema } = this.props;
    this.setState({
      currentValue: val,
    });
    onSearchTema(val);
  }

  _checkBlur(type) {
    const {
      levelOne, levelTwo, levelThree,
      levelFour,
    } = this.props;
    switch (type) {
      case 'class': {
        if (!levelOne) {
          this.canBlur = false;
        }
        break;
      }
      case 'category': {
        if (!levelTwo) {
          this.canBlur = false;
        }
        break;
      }
      case 'group': {
        if (!levelThree) {
          this.canBlur = false;
        }
        break;
      }
      case 'account': {
        if (!levelFour) {
          this.canBlur = false;
        }
        break;
      }
      default: {
        this.canBlur = true;
        break;
      }
    }
  }

  _onClick(obj) {
    const {
      name, fieldName, onClick,
      inputArray, arrayPosition,
    } = this.props;
    this._checkBlur(obj.type);

    if (this.canBlur) {
      this.setState({
        currentValue: '',
      });
      onClick({
        target: {
          name,
          value: obj,
          dataset: { inputArray, arrayPosition, fieldName },
        },
      });
    }
  }

  _onClear() {
    const {
      name, fieldName, onClick,
      inputArray, arrayPosition,
    } = this.props;
    this.setState({
      currentValue: '',
    });
    onClick({
      target: {
        name,
        value: { value: '', title: '' },
        dataset: { inputArray, arrayPosition, fieldName },
      },
    });
  }

  _onBlur() {
    const { onSearchTema } = this.props;
    if (this.canBlur) {
      this.setState({
        currentValue: '',
      });
      this.canBlur = false;
    } else {
      this.SelectTemaRefs.focus();
    }
    this.canBlur = true;
    onSearchTema('');
  }

  _getClickHandler(obj) {
    if (!Object.prototype.hasOwnProperty.call(this.clickHandlers, obj.value)) {
      this.clickHandlers[obj.value] = () => this._onClick(obj);
    }
    return this.clickHandlers[obj.value];
  }

  render() {
    const {
      currentValue,
    } = this.state;
    const {
      theme,
      tema,
      label,
      placeholder,
      error,
      classNames,
      disabled,
      value,
      leftIcon,
      rightIcon,
      noMargin,
      edit,
      levelOne,
      levelTwo,
      levelThree,
      levelFour,
    } = this.props;
    const loadingProps = { show: tema.loading };
    const wrapperClassnames = classnames([
      'select-coa',
      noMargin && 'select-coa__no-margin',
    ]);
    const labelClassnames = classnames([
      'select-coa__label',
      disabled && 'select-coa__text-disabled',
      error && 'select-coa__label--error',
    ]);
    const containerClassnames = classnames([
      'select-coa__container',
      disabled && 'select-coa__disabled',
      error && 'select-coa__container--error',
    ]);
    const titleClassnames = classnames([
      'select-coa__title',
      !levelOne && 'select-coa__text--disabled',
    ]);
    const categoryClassnames = classnames([
      'select-coa__category',
      !levelTwo && 'select-coa__text--disabled',
    ]);
    const groupClassnames = classnames([
      'select-coa__group',
      !levelThree && 'select-coa__text--disabled',
    ]);
    const accountClassnames = classnames([
      'select-coa__account',
      !levelFour && 'select-coa__text--disabled',
    ]);
    const inputClassnames = classnames([
      error && 'select-coa__text--error',
      value.value && 'select-coa__placeholder',
      disabled && 'select-coa__text-disabled select-coa__placeholder-disabled',

      `select-coa__text select-coa__text__${theme}`,
      leftIcon && `select-coa__text__${theme}--icon-left`,
      rightIcon && `select-coa__text__${theme}--icon-right`,
      disabled && 'select-coa__text--disabled',
      classNames,
    ]);

    return (
      <div className={wrapperClassnames}>
        {label && <label className={labelClassnames}>{label}</label>}
        <div className={containerClassnames}>
          { (value.value || currentValue) && edit
          && (
            <button
              type="button"
              className="select-coa__clear"
              onClick={this._onClear}
            >
              &times;
            </button>
          )
          }
          {
            edit ? (
              <input
                ref={this._setInputRef}
                type="text"
                placeholder={value.value ? `${value.value} - ${value.title}` : placeholder}
                className={inputClassnames}
                value={currentValue}
                onChange={this._onChange}
                onBlur={this._onBlur}
                disabled={disabled}
              />
            ) : <p className="search-select__preview">{value.value}</p>
          }

          <div className="select-coa__list">
            {
              loadingProps.show
                ? <Loading loading={loadingProps} black />
                : map(tema.list, (data, idx) => {
                  const { category: categories = [] } = data;
                  return (
                    <div
                      key={`select_coa_list_${idx}`}
                      className="select-coa__item"
                    >
                      <div>
                        <button
                          type="button"
                          className={titleClassnames}
                          onMouseDown={this._getClickHandler({
                            value: data.value,
                            title: data.label,
                            isCredit: data.type === 'K',
                            type: 'class',
                          })}
                        >
                          <p>
                            {data.value} - {data.label}
                          </p>
                        </button>
                        {
                          map(categories, (category, categoryIdx) => {
                            const { group: groups = [] } = category;
                            return (
                              <div key={`coa_category_${idx}_${categoryIdx}`}>
                                <button
                                  type="button"
                                  className={categoryClassnames}
                                  onMouseDown={this._getClickHandler({
                                    value: data.label,
                                    label: category.label,
                                    type: 'category',
                                  })}
                                >
                                  <p>
                                    {category.value} - {category.title}
                                  </p>
                                </button>
                                {
                                  map(groups, (group, groupIdx) => {
                                    const { account: accounts = [] } = group;
                                    return (
                                      <div key={`coa_group_${idx}_${categoryIdx}_${groupIdx}`}>
                                        <button
                                          type="button"
                                          className={groupClassnames}
                                          onMouseDown={this._getClickHandler({
                                            value: group.value,
                                            title: group.title,
                                            type: 'group',
                                          })}
                                        >
                                          <p>
                                            {group.value} - {group.title}
                                          </p>
                                        </button>
                                        {
                                          map(accounts, (account, accountIdx) => (
                                            <button
                                              type="button"
                                              key={`coa_account_${idx}_${categoryIdx}_${groupIdx}_${accountIdx}`}
                                              className={accountClassnames}
                                              onMouseDown={this._getClickHandler({
                                                value: account.value,
                                                title: account.title,
                                                type: 'account',
                                              })}
                                            >
                                              <p>
                                                {account.value} - {account.title}
                                              </p>
                                            </button>
                                          ))
                                        }
                                      </div>
                                    );
                                  })
                                }
                              </div>
                            );
                          })
                        }
                      </div>
                    </div>
                  );
                })
            }
          </div>
          {
            (leftIcon && edit)
            && (
              <span className={`select-coa__icon-left select-coa__icon-left__${theme}`}>
                {
                  typeof leftIcon === 'string'
                    ? <i className={leftIcon} />
                    : leftIcon
                }
              </span>
            )
          }
          {
            (rightIcon && edit)
            && (
              <span className={`select-coa__icon-right select-coa__icon-right__${theme}`}>
                {
                  typeof rightIcon === 'string'
                    ? <i className={rightIcon} />
                    : rightIcon
                }
              </span>
            )
          }
        </div>
        {error && <p className="select-coa__err">{error}</p>}
      </div>
    );
  }
}
SelectTema.propTypes = {
  levelOne: PropTypes.bool,
  levelTwo: PropTypes.bool,
  levelThree: PropTypes.bool,
  levelFour: PropTypes.bool,
  disabled: PropTypes.bool,
  noMargin: PropTypes.bool,
  inputArray: PropTypes.bool,
  edit: PropTypes.bool,
  arrayPosition: PropTypes.number,
  label: PropTypes.string,
  value: PropTypes.object,
  name: PropTypes.string,
  fieldName: PropTypes.string,
  placeholder: PropTypes.string,
  error: PropTypes.string,
  classNames: PropTypes.string,
  theme: PropTypes.string,
  leftIcon: PropTypes.string,
  rightIcon: PropTypes.string,
  onClick: PropTypes.func,
  tema: PropTypes.object.isRequired,
  onSearchTema: PropTypes.func,
};
SelectTema.defaultProps = {
  levelOne: true,
  levelTwo: true,
  levelThree: true,
  levelFour: true,
  disabled: false,
  noMargin: false,
  inputArray: false,
  edit: true,
  arrayPosition: 0,
  theme: 'default',
  label: '',
  placeholder: '',
  error: '',
  classNames: '',
  name: '',
  fieldName: '',
  value: { value: '', title: '' },
  onClick: noop,
  leftIcon: '',
  rightIcon: '',
  onSearchTema: noop,
};
